module.exports = __webpack_public_path__ + "img/bulk-booking.4d02c511.svg";